import * as React from "react";
import { ApiMe } from "../misc/api/AccountServer/AccountApi";

declare const accountServerEnabled: boolean;

export const useAccountKeepAlive = () => {
    const [isActive, setIsActive] = React.useState(false);

    React.useEffect(() => {
        let interval = null;
        if (!isActive && accountServerEnabled) {
            ApiMe();

            interval = setInterval(() => {
                ApiMe()
                    .then(response => {
                        if (response.status === 401)
                            clearInterval(interval);
                    });
            }, 600000);
            setIsActive(true);
        }
        return () => clearInterval(interval);
    }, [accountServerEnabled]);

    return { isActive };
};
